<template>
  <div class="my-menu-div">
    <div class="my-menu">
      <el-menu :default-active="getActiveIndex" class="el-menu-demo" mode="horizontal" style="background: #D3D4D6"
        :router="Boolean(1)">
        <el-menu-item index="1" style="padding:0 43.5px;" route="/"><span class="my-menu-span">网站首页</span></el-menu-item>
        <el-menu-item index="2" style="padding:0 43.5px;" route="/summarized"><span class="my-menu-span">公司简介</span></el-menu-item>
        <el-menu-item index="3" style="padding:0 43.5px;" route="/item/index"><span class="my-menu-span">产品展示</span></el-menu-item>
        <el-menu-item index="4" style="padding:0 44px;" route="/news/index"><span class="my-menu-span">新闻中心</span></el-menu-item>
        <el-menu-item index="5" style="padding:0 44px;" route="/aftermarket"><span class="my-menu-span">售后服务</span></el-menu-item>
        <el-menu-item index="6" style="padding:0 44px;" route="/message"><span class="my-menu-span">留言反馈</span></el-menu-item>
        <el-menu-item index="7" style="padding:0 43.5px;" route="/contact"><span class="my-menu-span">联系我们</span></el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  export default {
    name: "Menu",
    data: function() {
      return {}
    },
    methods: {},
    computed: {
      ...Vuex.mapGetters(["getActiveIndex"])
    }
  }
</script>

<style>
  .my-menu {
    width: 1200px;
    margin: 0 auto;
  }

  .my-menu-div {
    background: #F2F2F2;
  }

  .my-menu-span {
    font-size: 21px;
    color: #555555;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Menu.vue